import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';

import styles from '../routes/subroutes/Resume.module.scss';

interface ResumeSectionProps {
  eventKey: string;
  title: string;
  onNavigate: (key: string) => void;
  prevButtonText?: string;
  prevEventKey?: string;
  nextButtonText?: string;
  nextEventKey?: string;
  children: React.ReactNode;
  headerRef?: (el: HTMLDivElement | null) => void;
}

const ResumeSection = ({
  eventKey,
  title,
  onNavigate,
  prevButtonText,
  prevEventKey,
  nextButtonText,
  nextEventKey,
  children,
  headerRef,
}: ResumeSectionProps) => {
  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header as={'h5'} ref={headerRef}>
        {title}
      </Accordion.Header>
      <Accordion.Body className={styles['accordion-body']}>
        {children}
        <div className={styles['accordion-nav']}>
          {prevButtonText && prevEventKey && (
            <Button
              size="sm"
              variant="outline-dark"
              onClick={() => onNavigate(prevEventKey)}
            >
              &uarr; {prevButtonText}
            </Button>
          )}
          {nextButtonText && nextEventKey && (
            <Button
              size="sm"
              variant="outline-dark"
              onClick={() => onNavigate(nextEventKey)}
            >
              {nextButtonText} &darr;
            </Button>
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default ResumeSection;
